var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4816_77978)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4816_77978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9999V31.9999C16 33.676 16 34.514 16.5207 35.0347C17.0414 35.5554 17.8795 35.5554 19.5556 35.5554H28.4444C30.1205 35.5554 30.9586 35.5554 31.4793 35.0347C32 34.514 32 33.676 32 31.9999V19.1276C32 18.3863 32 18.0156 31.8597 17.6837C31.7193 17.3518 31.4535 17.0935 30.9217 16.577L27.7014 13.4493C27.1906 12.9532 26.9352 12.7052 26.6138 12.5747C26.2923 12.4443 25.9363 12.4443 25.2242 12.4443H19.5556C17.8795 12.4443 17.0414 12.4443 16.5207 12.965C16 13.4857 16 14.3238 16 15.9999Z",
    stroke: "#707070",
    strokeWidth: 1.77778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 13.333V15.1108C26.6665 16.7869 26.6665 17.6249 27.1872 18.1456C27.7079 18.6663 28.546 18.6663 30.2221 18.6663H31.9998",
    stroke: "#707070",
    strokeWidth: 1.77778
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4443 31.1114H25.7777M20.4443 24.8892H29.3332M20.4443 18.667H23.111",
    stroke: "#707070",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4816_77978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4816_77978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepGeneral);
export default __webpack_public_path__ + "static/media/undone-step-general.d8a3c366cfa2ef8d0e7ec40f9754d345.svg";
export { ForwardRef as ReactComponent };